import Card from "components/card";
import Loader from "components/loader";
import useStats from "hooks/useStats";
import { useEffect } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { routesNames } from "utils/Constants";

const columns = [
  {
    title: "Postulante",
    dataIndex: "name",
    render: (text, record) => (
      <Link to={`${routesNames.USER}/${record.user_id}`} className="text-sm font-semibold text-blue-800 dark:text-white">
        {text}
      </Link>
    ),
  },
  {
    title: "Postulaciones",
    dataIndex: "postulaciones",
  },
  {
    title: "Espontáneas",
    dataIndex: "espontaneas",
  },
  {
    title: "% Espontáneas",
    dataIndex: "porcentaje_espontaneas",
    render: (text, record) => {
      const total = Number(record?.postulaciones || 0);
      const espontaneas = Number(record?.espontaneas || 0);
      const pct = total > 0 ? Math.round((espontaneas / total) * 1000) / 10 : 0;
      return `${pct}%`;
    },
  },
];

const TopPostulantesTable = () => {
  const { isLoading, response, fetchData } = useStats("top-postulantes");

  useEffect(() => {
    fetchData(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = Array.isArray(response) ? response : [];

  return (
    <Card extra="w-full h-full px-6 py-4">
      <div className="text-xl font-bold text-navy-700 dark:text-white mb-2">
        Top 10 postulantes más activos
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <Table
          columns={columns}
          dataSource={rows}
          rowKey={(record) => record.user_id}
          size="small"
          pagination={false}
          locale={{ emptyText: "No hay datos disponibles" }}
        />
      )}
    </Card>
  );
};

export default TopPostulantesTable;
